import { shareColumnsExtend, shareFormColumnsExtend } from './share';
export const BANNER_PAGE_POSITIONS = [
  'event',
]

export const BANNER_KINDS = [
  'web_link',
  'image',
  'mp_link',
]

const entityColumns = {
  id: {
    model_name: 'Banner',
    column_type: 'id',
    label_key_path: 'banner.id',
  },
  created_at: {
    model_name: 'Banner',
    column_type: 'datetime',
    label_key_path: 'banner.createdAt',
  },
  updated_at: {
    model_name: 'Banner',
    column_type: 'datetime',
    label_key_path: 'banner.updatedAt',
  },
  target: {
    model_name: 'Banner',
    column_type: 'string',
    label_key_path: 'banner.target',
  },
  position: {
    model_name: 'Banner',
    column_type: 'integer',
    label_key_path: 'banner.position',
  },
  page_position: {
    model_name: 'Banner',
    column_type: 'enum',
    extra: {
      options: ['event'],
    },
    label_key_path: 'banner.pagePosition',
  },
  kind: {
    model_name: 'Banner',
    column_type: 'enum',
    extra: {
      options: ['web_link', 'image', 'mp_link'],
    },
    label_key_path: 'banner.kind',
  },
  alt: {
    model_name: 'Banner',
    column_type: 'string',
    label_key_path: 'banner.alt',
  },
  image: {
    model_name: 'Banner',
    column_type: 'attached',
    extra: {
      size: 20,
    },
    label_key_path: 'banner.image',
  },
  image_with_audio: {
    model_name: 'Banner',
    prop: 'image_attachment',
    label_key_path: 'banner.imageAttachment',
    column_type: 'attached',
    extra: {
      accept: 'audio/mp3, audio/aac',
      type: 'audio',
      size: 20,
    },
  },
}

export const columnsExtend = (columns) => {
  return shareColumnsExtend(entityColumns, columns)
}

export const formColumnsExtend = (columns, { formColumnsConfig = {}, type, data }) => {
  return shareFormColumnsExtend(entityColumns, columns, { formColumnsConfig, type, data })
}
